import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { program } from '../mockData';
import { Card, CardContent } from '../components/ui/card';

const Program = () => {
  const { language } = useLanguage();
  const t = program[language];

  return (
    <div className="min-h-screen bg-page py-32">
      <div className="container mx-auto px-8">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-20 animate-fade-in">
          <h1 className="heading-1 text-gold mb-8">{t.title}</h1>
        </div>

        {/* Program Items */}
        <div className="max-w-6xl mx-auto space-y-12">
          {t.items.map((item, index) => (
            <Card
              key={item.id}
              className="overflow-hidden bg-card-dark border-gold/20 hover:border-gold/50 transition-all duration-300 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="grid grid-cols-1 md:grid-cols-2">
                {/* Image */}
                <div className="relative h-64 md:h-auto overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>

                {/* Content */}
                <CardContent className="p-8 md:p-12 flex flex-col justify-center">
                  <h3 className="heading-4 text-gold mb-4">{item.title}</h3>
                  <p className="body-medium text-gray-300">{item.desc}</p>
                </CardContent>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Program;